 
export interface IProfileContact {
    firstName: string;
    lastName: string;
    phoneNumber: string ;
    billingCity: string;
    billingPostalCode: string;
    billingStreet: string;
    billingEmail: string;
    city: string;
    street: string;
    postalCode: string;

    company:string;
    dic: string;
    ic: string;
    differentBillingAddress: boolean;

} 

export const EmptyProfileContact = (): IProfileContact => {
    const profile: IProfileContact = {
        firstName: "",
        lastName:"",
        phoneNumber: "",
        billingCity: "",
        billingPostalCode: "",
        billingStreet: "",
        billingEmail: "",
        city: "",
        street: "",
        postalCode: "",     
        company: "",
        dic: "",
        ic: "",
        differentBillingAddress: false,
        
    }

    return profile
}